'use strict';
module.exports = function toggleInArray(array, value) {
	if (Array.isArray(array)) {
		if (!array.includes(value)) {
			return [value].concat(array);
		}
		const result = array.filter(t => t != value); //eslint-disable-line eqeqeq
		if (result.length === 0) {
			return undefined;
		}
		return result;
	}
	return [value];
};
